import React from 'react'
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import WhyChooseUs from '../components/WhyChooseUs';
import OurService from '../components/OurService';
import OurProject from '../components/OurProject';
import OurSkills from '../components/OurSkills';
import HowWeWork from '../components/HowWeWork';
import Testimonials from '../components/Testimonials';
import IntroVideo from '../components/IntroVideo';

const Home = () => {
  return (
    <>
      <Hero />
      <AboutUs />
      <WhyChooseUs/>
      <OurService />
      <IntroVideo />
      <OurProject />
      <HowWeWork />
      <OurSkills />
      {/* <Testimonials /> */}
    </>

  )
}

export default Home
